import { Button, Flex, Text } from "@chakra-ui/react";

interface FormFooterProps {
  authStyles: any;
  isLoading: boolean;
  onSignIn: () => void;
}

export function FormFooter({
  authStyles,
  isLoading,
  onSignIn,
}: FormFooterProps) {
  return (
    <Flex
      w="100%"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      gap="16px"
      mt="24px"
    >
      <Button
        type="submit"
        {...authStyles.button?.primary}
        bgColor="#3A7BFF"
        h="48px"
        w="168px"
        isLoading={isLoading}
        isDisabled={isLoading}
        border="1px solid #2C63E5"
        _hover={{
          bgColor: "#FFFFFF",
          color: "#2C63E5",
        }}
        _loading={{ pointerEvents: "none" }}
        _active={{
          bgColor: "#FFFFFF",
          color: "#2C63E5",
        }}
      >
        Create account
      </Button>
      <Flex justifyContent="center" align="center">
        <Text fontSize="14px" color="#0B0E10" fontWeight="500">
          Already have an account?{" "}
          <Text
            as="span"
            color="#155EEF"
            textDecoration="underline"
            fontWeight="500"
            cursor="pointer"
            onClick={onSignIn}
            _hover={{ textDecoration: "underline" }}
          >
            Log in
          </Text>
        </Text>
      </Flex>
    </Flex>
  );
}
